export const scrollToBottom = () => {
  const windowHeight = window.innerHeight;
  const fullHeight = document.body.scrollHeight;
  window.scrollTo(0, fullHeight - windowHeight);
};
